import { ShippingDocumentKind, WasteManifestSource } from "generated-graphql/graphql";

import { BILL_OF_LADING_SOURCES } from "../../../Manifests/sections/billOfLadingSummary";
import { SourcesCell } from "../../../Manifests/SourcesCell";

/** A line's Sources pills; a bill of lading line shows only Document and Vendor. */
export function LineSourcesCell({
  row,
}: {
  row: {
    availableSources?: readonly WasteManifestSource[] | null;
    documentKind: ShippingDocumentKind;
  };
}) {
  return (
    <SourcesCell
      availableSources={row.availableSources ?? []}
      sourceOrder={
        row.documentKind === ShippingDocumentKind.BillOfLading ? BILL_OF_LADING_SOURCES : undefined
      }
    />
  );
}
